"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
var TweekClient_1 = __importDefault(require("./TweekClient"));
function createTweekClient(_a) {
    var baseServiceUrl = _a.baseServiceUrl, _b = _a.context, context = _b === void 0 ? {} : _b, useLegacyEndpoint = _a.useLegacyEndpoint, fetchClientConfig = __rest(_a, ["baseServiceUrl", "context", "useLegacyEndpoint"]);
    return new TweekClient_1.default({
        baseServiceUrl: baseServiceUrl,
        context: context,
        fetch: utils_1.createFetchClient(fetchClientConfig),
    }, useLegacyEndpoint);
}
exports.createTweekClient = createTweekClient;
//# sourceMappingURL=createTweekClient.js.map